import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {auth} from '../services/auth';
import {FCCMDashboard} from './FCCMDashboard';
import {DeereLogo} from './DeereLogo';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import styles from './AppWrapper.css';

const theme = createTheme({
    palette: {
        primary: {
            main: '#367C2B'
        },
        secondary: {
            main: '#FFF'
        }
    }
});

export function AppWrapper({error}) {
    return (
        <ThemeProvider theme={theme}>
            {error ? (
                <div className={styles.root}>
                    <DeereLogo className={styles.logo} component="div"/>
                    <Paper className={styles.error}>
                        <Typography variant="h5">Access Denied</Typography>
                        <Typography>{error.description.replace(/\+/g, ' ')}</Typography>
                        <Button
                            color="primary" fullWidth
                            onClick={() => auth.loginWithRedirect()}
                            variant="outlined">
                            Retry
                        </Button>
                    </Paper>
                </div>
            ) : <FCCMDashboard/>}
        </ThemeProvider>
    );
}
